import { UIHeading4, UIText2 } from '@cian/ui-kit';

import * as styles from './KokonTooltipContent.css';
import { KOKON_CERTIFICATE_URL } from '../../constants/links';

export const KokonTooltipContent = () => {
  return (
    <div className={styles['container']}>
      <UIHeading4>Агентство входит в ассоциацию КОКОН</UIHeading4>
      <a className={styles['link']} href={KOKON_CERTIFICATE_URL} target="_blank" rel="noopener noreferrer">
        <UIText2 color="primary_100">Подробнее</UIText2>
      </a>
      <UIText2>
        Компания является участником профессиональной ассоциации консультантов коммерческой недвижимости и&nbsp;работает
        в&nbsp;соответствии с&nbsp;утверждёнными стандартами качества услуг
      </UIText2>
    </div>
  );
};
